// extracted by mini-css-extract-plugin
export default {"container":"style_container__2hcIp","title":"style_title__ppFgk","divider":"style_divider__v78vd","children":"style_children__JATvF","formFooter":"style_formFooter__VUBRF"};